import Vue from 'vue';

export class Tk{

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-tk/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendIp(json){
        return Vue.http.post('configuracao-tk/ip', json);
    }

    static sendIpAll(json){
        return Vue.http.post('configuracao-tk/ip/all', json);
    }

    static sendTempos(json){
        return Vue.http.post('configuracao-tk/times', json);
    }

    static sendTemposAll(json){
        return Vue.http.post('configuracao-tk/times/all', json);
    }

    static sendProtocol18(idRastreador){
        return Vue.http.post('configuracao-tk/protocol-18', {
            id_rastreador: idRastreador
        });
    }

}
